import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import WhitelabelConfigColorPaletteService from '../services/WhitelabelConfigColorPaletteService';
import WhitelabelConfigColorPaletteForm from './WhitelabelConfigColorPaletteForm';

class WhitelabelConfigColorPaletteFormContainer extends Component {
  static propTypes = {
    whitelabelConfigId: PropTypes.string,
  };

  static defaultProps = {
    whitelabelConfigId: null,
  };

  whitelabelConfigColorPaletteService = new WhitelabelConfigColorPaletteService();
  componentWillMount() {
    this.whitelabelConfigColorPaletteService.init(this.props.whitelabelConfigId);
  }

  render() {
    return (
      <WhitelabelConfigColorPaletteForm
        onSubmit={this.whitelabelConfigColorPaletteService.handleSubmit}
        onChange={this.whitelabelConfigColorPaletteService.form.setValue}
        onReset={this.whitelabelConfigColorPaletteService.form.reset}
        values={this.whitelabelConfigColorPaletteService.form.getValues()}
        errors={this.whitelabelConfigColorPaletteService.form.errors}
        submitting={this.whitelabelConfigColorPaletteService.submit.fetching}
        isDirty={this.whitelabelConfigColorPaletteService.form.isDirty}
      />
    );
  }
}

export default observer(WhitelabelConfigColorPaletteFormContainer);
